import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

/** A category ticked in Configuration › Evaluation › Category; label is "long label | division". */
export interface SelectedEvaluationCategory {
  shortLabel: string;
  division: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class EvaluationFilterService {
  private API_URL = `${environment.apiUrl}/evaluation-filter`;

  constructor(
    private http: HttpClient,
  ){}

  getEvaluationFilter(): Observable<any> {
    return this.http.get<String>(this.API_URL);
  }

  /** The ticked categories, readable by evaluators: the evaluation page only lists employees in them. */
  getSelectedCategories(): Observable<SelectedEvaluationCategory[]> {
    return this.http.get<SelectedEvaluationCategory[]>(`${this.API_URL}/categories`);
  }

  updateEvaluationFilter(filter: String): Observable<any> {
    return this.http.put(this.API_URL, filter);
  }
}
